/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHeapAnalysisProcess {
    getFixupPrototypeFunction() { return BackgroundJobHeapAnalysisProcess.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHeapAnalysisProcess>): BackgroundJobHeapAnalysisProcess {
        let obj = Object.assign(new BackgroundJobHeapAnalysisProcess(), model);
        BackgroundJobHeapAnalysisProcess.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHeapAnalysisProcess>): BackgroundJobHeapAnalysisProcess {
        if (!model) return null;
        return BackgroundJobHeapAnalysisProcess.newInstance(<BackgroundJobHeapAnalysisProcess> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHeapAnalysisProcess) {
        if (!obj) return;

        models.BackgroundJobHeapAnalysisProcess.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHeapAnalysisProcess): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHeapAnalysisProcess.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.modules) {
            for (let val of this.modules) {
                models.BackgroundJobHeapAnalysisModule.fixupPrototype(val);
            }
        }
    }

    /**
     * Process name
     */
    name: string;

    /**
     * Module data
     */
    modules: Array<models.BackgroundJobHeapAnalysisModule>;

}
